var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "mx-auto rounded-lg my-2",
      attrs: { "max-width": "375", elevation: "0" },
    },
    [
      _c(
        "v-img",
        {
          attrs: {
            src: _vm.settings.profile_image ? _vm.settings.profile_image : "",
            height: "300px",
            dark: "",
            gradient: "to top, rgba(0,0,0,.8), rgba(0,0,0,.0), rgba(0,0,0,.0)",
            position: "top center",
            color: "primary",
          },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "fill-height ml-2",
              staticStyle: { "align-items": "end" },
            },
            [
              _c("v-card-title", { staticClass: "white--text pl-1 py-0" }, [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm.settings.profile_name) + " "),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "text--disabled",
                    staticStyle: {
                      "font-size": "0.8em",
                      "line-height": "1",
                      width: "100%",
                    },
                  },
                  [_vm._v(_vm._s(_vm.settings.profile_job_title))]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.settings.profile_description
        ? _c("v-card-text", [
            _vm._v(" " + _vm._s(_vm.settings.profile_description) + " "),
          ])
        : _vm._e(),
      _c(
        "v-list",
        { attrs: { "two-line": "" } },
        [
          _vm.settings.profile_phone_number
            ? _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v(" mdi-phone "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.settings.profile_phone_number)),
                      ]),
                      _c("v-list-item-subtitle", [_vm._v("Phone")]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("v-divider", { attrs: { inset: "" } }),
          _vm.settings.profile_email_address
            ? _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v(" mdi-email "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.settings.profile_email_address)),
                      ]),
                      _c("v-list-item-subtitle", [_vm._v("Email")]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }